import React from 'react';

import MultiPackage from '../../../../fulfillment-plans/shipments-display/components/multi-package';
import { PackageLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

const PackageType = () => {
  const { isMultiPackage, packageType } = useFulfillmentDisplayContext();

  return <ReadonlyField label={PackageLabel}>{isMultiPackage ? <MultiPackage /> : packageType}</ReadonlyField>;
};

export default PackageType;
